import { Inject, Injectable, Optional } from '@angular/core';
import {
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
  MatDialog as MatDialog,
} from '@angular/material/dialog';
import { InfoPopupDialogComponent } from '../../info-popup-dialog/info-popup-dialog.component';

@Injectable({ providedIn: 'root' })
export class InfoDialogService {
  private readonly ONE_DAY = 24 * 60 * 60 * 1000;
  private readonly POPUP_COUNT = 5

  constructor(
    private dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data
  ) {}

  tryShow(userId: number, isLarge: boolean) {
    if (!userId) return;

    const key = `infoPopupData_${isLarge ? 'customer' : 'jobseeker'}_${userId}`;
    const raw = localStorage.getItem(key);
    const popupData = raw ? JSON.parse(raw) : { count: 0, lastShown: null };

    const now = Date.now();
    const canShow =
      popupData.count < this.POPUP_COUNT &&
      (!popupData.lastShown || now - popupData.lastShown > this.ONE_DAY);

    if (canShow) {
      const dialogRef = this.dialog.open(InfoPopupDialogComponent, {
        disableClose: true,
        data: { isLarge: isLarge },
        maxWidth: '830px',
        panelClass: 'custom-dialog-panel',
      });

      dialogRef.afterClosed().subscribe(() => {
        localStorage.setItem(
          key,
          JSON.stringify({
            count: popupData.count + 1,
            lastShown: now,
          })
        );
      });
    }
  }
}


